export default __webpack_public_path__ + "static/media/mysore palace.a8082b29.jpg";